export default "__VITE_ASSET__DvmOUoBb__"